import type { ApiProyectoFull } from "@/@types/Api_Extracted";
import { Button } from "@/components/ui/button";

export function FormsView(props: { readonly idProyecto: string; }) {
	const download = (reportType: string) => {
		// Aquí iría la lógica para descargar el informe correspondiente
		console.log(`Descargando informe: ${reportType}`);
	};

	return (
		<div>
			<h2 className="text-xl font-bold">Informes disponibles</h2>
			<ul className="list-disc ml-5">
				<li>
					<Button
						variant="link"
						size="text"
						onClick={() => download("InformeTecnico")}
					>
						Informe técnico completo
					</Button>
				</li>
				<li>
					<Button
						variant="link"
						size="text"
						onClick={() => download("InformeCliente")}
					>
						Informe para cliente
					</Button>
				</li>
				<li>
					<Button
						variant="link"
						size="text"
						onClick={() => download("CicloDeVida")}
					>
						Inventario de ciclo de vida
					</Button>
				</li>
				<li>
					<Button
						variant="link"
						size="text"
						onClick={() => download("DatosIntroducidos")}
					>
						Datos introducidos por el usuario
					</Button>
				</li>
				<li>
					<Button
						variant="link"
						size="text"
						onClick={() => download("DatosEstimados")}
					>
						Datos estimados por la aplicación
					</Button>
				</li>
				<li>
					<Button
						variant="link"
						size="text"
						onClick={() => download("FactoresUsados")}
					>
						Factores usados por la aplicación
					</Button>
				</li>
				<li>
					<Button
						variant="link"
						size="text"
						onClick={() => download("ReglasAsignacion")}
					>
						Reglas de asignación
					</Button>
				</li>
				<li>
					<Button
						variant="link"
						size="text"
						onClick={() => download("CalidadDeDatos")}
					>
						Calidad de los datos
					</Button>
				</li>
				<li>
					<Button
						variant="link"
						size="text"
						onClick={() => download("Trazabilidad")}
					>
						Trazabilidad del cálculo
					</Button>
				</li>
				<li>
					<Button
						variant="link"
						size="text"
						onClick={() => download("ExportadoPDF")}
					>
						Exportación PDF
					</Button>
				</li>
				<li>
					<Button
						variant="link"
						size="text"
						onClick={() => download("ExportadoExcel")}
					>
						Exportación Excel
					</Button>
				</li>
			</ul>
		</div>
	);
}
